import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';

export const HeaderSection = styled('header')`
	margin: 0 auto;
	padding: 1rem 0 2rem 0;

	.ant-row-space-between {
		align-items: center;
		text-align: center;
	}
`;

export const LogoContainer = styled(Link)`
	display: flex;
`;

export const NavLink = styled('div')`
	display: inline-block;
	text-align: center;
`;

export const CustomNavLink = styled('div')`
	width: 170px;
	display: inline-block;

	@media only screen and (max-width: 411px) {
		width: 150px;
	}

	@media only screen and (max-width: 320px) {
		width: 118px;
	}
`;

export const Burger = styled('div')`
	@media only screen and (max-width: 890px) {
		display: block;
	}

	display: none;

	svg {
		fill: #cdcdcd;
	}
`;

export const NotHidden = styled('div')`
	@media only screen and (max-width: 890px) {
		display: none;
	}
`;

export const Menu = styled('h5')`
	text-align: center;
	text-underline-position: under;
	text-decoration: #cdcdcd underline;
	font-size: 1.5rem;
	font-weight: 700;
	align-items: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
	font-size: 1.3rem;
	color: #9c9c9c;
	transition: color 0.2s ease-in;
	margin: 0.5rem 1rem;

	@media only screen and (max-width: 768px) {
		margin: 0.8rem 2rem;
	}
`;

export const Label = styled('span')`
	font-weight: 500;
	color: #9c9c9c;
	text-align: right;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const Outline = styled(MenuOutlined)<any>`
	font-size: 22px;
`;

export const Span = styled('span')`
	cursor: pointer;
	transition: all 0.3s ease-in-out;

	&:hover,
	&:active,
	&:focus {
		color: #cdcdcd;
		text-underline-position: under;
		text-decoration: #cdcdcd underline;
	}
`;
